import { listenTrialMaxWords } from '@/environment';
import { DidUser, useAuth } from '@/services/auth';
import { PlanGroup } from '@d-id/types';

export const isTtsOverLimit = (text: string, maxWords: number, user?: DidUser | null, isAnonymous?: boolean) => {
    const shouldRestrict = isAnonymous || user?.planGroup === PlanGroup.TRIAL;
    const wordLimitExceeded = shouldRestrict ? text.split(/\s+/).filter(word => word !== '⏱').length > maxWords : false;

    return wordLimitExceeded;
};

export function useIsTtsOverLimit(text: string) {
    const { user, isAnonymous } = useAuth();

    return isTtsOverLimit(text, listenTrialMaxWords, user || null, !!isAnonymous);
}
